import styled from 'styled-components';


export const Div = styled.div`
    width: 450px;
    height: 450px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    position: relative;
    top: 20.8%;
    transform: translateY(-50%);
  @media (max-width: 768px) {
    width: 400px;
    height: auto; 
    top: 24%;
  }

`;